import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ApiList from "./tabs/ApiList";
import LoggingHistory from "./tabs/LoggingHistory";
import DataSyncHistory from "./tabs/DataSyncHistory";

export default function SyncContainer() {
  const [activeTab, setActiveTab] = useState("apiList");

  const Links = [
    { to: "apiList", content: "Api List" },
    { to: "LoggingHistory", content: "Logging History" },
    // { to: "DataSyncHistory", content: "Data Sync History" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "apiList":
        return <ApiList />;
      case "LoggingHistory":
        return <LoggingHistory />;
      case "DataSyncHistory":
        return <DataSyncHistory />;
      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row" style={{ margin: "5px -15px" }}>
        <div className="col-md-12">
          <div className="white_shd full">
            <div className="tabbar padding_infor_info_p-d-5">
              <div>
                <div
                  className="d-flex align-items-center page-title position-relative mb-0"
                  style={{
                    paddingTop: "8px",
                    padding: "0px",
                  }}
                >
                  <ul className="nav nav-tabs">
                    {Links.map(({ to, content }) => (
                      <Tab
                        key={to}
                        tabKey={to}
                        activeTab={activeTab}
                        onClick={setActiveTab}
                      >
                        {content}
                      </Tab>
                    ))}
                  </ul>
                </div>
                <hr
                  style={{
                    // border: "1px solid rgb(221, 221, 221)",
                    margin: "0px -11px 5px",
                  }}
                />
              </div>
              <div className="tab-content">{renderTabContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Tab({ children, activeTab, tabKey, onClick }) {
  return (
    <li className="nav-item" onClick={() => onClick(tabKey)}>
      <a
        className={`nav-link ${activeTab === tabKey ? "active" : ""} pointer`}
        href={`#${tabKey}`}
        style={{
          padding: "10px 15px",
          border: activeTab === tabKey && "1px solid #ddd",
          borderBottomColor: activeTab === tabKey && "#00000000",
          backgroundColor: activeTab === tabKey && "#fff",
        }}
      >
        {children}
      </a>
    </li>
  );
}
